import { Theme } from '@logto/schemas';
import { useEffect, useContext } from 'react';

import PageContext from '@/Providers/PageContextProvider/PageContext';

// Authentication and its previews consistently use the Agent panel's dark appearance.
export const getThemeBySystemConfiguration = (): Theme => Theme.Dark;

export default function useTheme() {
  const { isPreview, setTheme } = useContext(PageContext);
  useEffect(() => {
    if (!isPreview) {
      setTheme(Theme.Dark);
    }
  }, [isPreview, setTheme]);
}
